import { createSlice } from '@reduxjs/toolkit';

export const countrySlice = createSlice({
  name: 'country',
  initialState: {
    country: [],
    country_list: [],
    country_list_select: [],
  },
  reducers: {
    setCountryRedux: (state, { payload }) => {
      state.country_list = payload;
    },
    setCountrysRedux: (state, { payload }) => {
      state.country_list = payload;
    },
    setCountrySelectRedux: (state, { payload }) => {
      state.country_list_select = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCountryRedux, setCountrysRedux, setCountrySelectRedux } = countrySlice.actions;
